const firebaseConfig = {
    apiKey: "AIzaSyDQ8rgCr0gxYdqtIcQzzXncWUraucvDIqc",
    authDomain: "travel-guru-29853.firebaseapp.com",
    databaseURL: "https://travel-guru-29853.firebaseio.com",
    projectId: "travel-guru-29853",
    storageBucket: "travel-guru-29853.appspot.com",
    messagingSenderId: "376925821197",
    appId: "1:376925821197:web:885ff7a625dec3b9f3f844"
  };

export default firebaseConfig;